import startsWith from 'lodash-es/startsWith';

/**
 * We use a local id in cases like offline folder creation or offline reply
 * where the local object has no server id.
 */
const localIdPrefix = 'local-';

export function isLocalId(id: string | undefined | null) {
    return id && startsWith(id, localIdPrefix);
}

export function createLocalId(id: string) {
    return `${localIdPrefix}${id}`;
}

export function getIdFromLocalId(localId: string) {
    return localId.slice(localIdPrefix.length);
}

export function tryGetIdFromLocalId(localId: string) {
    return isLocalId(localId) ? getIdFromLocalId(localId) : null;
}
